import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ValidationStatus, ValidationTestResult } from "../../_services/device-data-validation.service";
import "./commission-check.component.scss";
@Component({
    selector: "commission-check",
    template: require("./commission-check.component.html")
})
export class CommissionCheckComponent implements OnChanges {
    // bindings
    @Input() result: ValidationTestResult;
    // component
    icon: string;
    label: string;
    ValidationStatus = ValidationStatus;
    constructor() {
    }
    ngOnChanges(onChangesObj: SimpleChanges): void {
        if (!this.result) {
            return;
        }
        this.updateState();
    }
    // ---
    private updateState(): void {
        if (!this.result) {
            return;
        }
        this.label = this.result.TestResponseString;
        if (this.result.Status == ValidationStatus.Pass) {
            this.icon = `check_circle`;
            return;
        }
        this.icon = `highlight_off`;
        this.label = this.result.TestResponseString;
    }
}
